import React from 'react';
import { useClientStore } from 'apps/hooks';
import { observer } from 'mobx-react';
import { ChangeRoleAction } from 'libs/connection/actions';
import { Paragraph, Box, SvgIcon } from 'components';
import { InfoIcon } from 'icons';
import { ComponentBaseProps } from 'types';
import { useGetSystemCondition } from 'hooks';

export const ChangePortalBanner = observer((props: ComponentBaseProps) => {
  const clientStore = useClientStore();
  const hasIntermediatorRole = clientStore.hasRole('INTERMEDIATOR');

  if (!hasIntermediatorRole) return null;

  return (
    <div {...props}>
      <ChangeRoleAction data-for='change-action' />
    </div>
  );
});

export const IntermediatorSwitcherDescription = observer(
  (props: ComponentBaseProps) => {
    const clientStore = useClientStore();
    const { shouldShowIntermediatorSwitcher } = useGetSystemCondition();
    const hasIntermediatorRole = clientStore.hasRole('INTERMEDIATOR');

    const isIntermediatorPortal = clientStore.currentPortal === 'INTERMEDIATOR';

    if (hasIntermediatorRole && shouldShowIntermediatorSwitcher) {
      return (
        <div {...props}>
          <Box mt={1} sx={{ display: 'flex', alignItems: 'center' }}>
            <SvgIcon size='small' icon={<InfoIcon />} color='primary' />
            <Paragraph variant='accent' ml={2}>
              {isIntermediatorPortal
                ? "You're viewing as an Intermediator. You can see all RFQs and Orders."
                : "You're viewing this as a normal user."}
            </Paragraph>
          </Box>
        </div>
      );
    }

    return null;
  },
);
